import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";
import "firebase/auth";
import { Notification, Loading } from "element-ui";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Auth",
      component: require("@/pages/Auth/index").default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/registration",
      name: "Beta",
      component: require("@/pages/Beta/index").default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/forgot",
      name: "ForgotPassword",
      component: require("@/pages/Forms/ForgotPassword/index").default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/auth-reset-password",
      name: "AuthResetPassword",
      component: require("@/pages/Forms/ResetPassword/Authed").default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: require("@/pages/Forms/ResetPassword/notAuthed").default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/game",
      name: "Game",
      component: require("@/pages/Game/index").default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: require("@/pages/Dashboard/index").default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lesson",
      name: "Lesson",
      component: require("@/pages/Lesson/index").default,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/test",
      name: "Test",
      component: require("@/pages/Test/index").default,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/subscribe",
      name: "Subscription",
      component: require("@/pages/Subscription/index").default,
      // props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/settings",
      name: "Settings",
      component: require("@/pages/Settings/index").default,
      // props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/faq",
      name: "Faq",
      component: require("@/pages/Faq/index").default,
      // props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/p_faq",
      name: "PublicFaq",
      component: require("@/pages/PublicFaq/index").default,
      // props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: require("@/pages/Register").default,
      props: true
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    // This is the workaround
    if (to.name === "dashboard" && from.name === "lessons") {
      return savedPosition;
    }

    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;

  // signout if user has query
  if (to.name === "Auth" && to.query.email && currentUser) {
    // store.commit("clearUserData");
    let loading = Loading.service({ fullscreen: true });
    firebase
      .auth()
      .signOut()
      .then(async () => {
        await store.dispatch("loadUserData", null, { root: true });

        next({
          path: "/",
          query: {
            keyCode: decodeURI(to.query.keyCode),
            email: decodeURI(to.query.email)
          }
        });
        loading.close();
      });
  }

  if (to.name === "ResetPassword" && currentUser) {
    // store.commit("clearUserData");

    let loading = Loading.service({ fullscreen: true });

    firebase
      .auth()
      .signOut()
      .then(async () => {
        await store.dispatch("loadUserData", null, { root: true });
        next({
          path: "/reset-password",
          query: {
            oobCode: decodeURI(to.query.oobCode)
          }
        });
        loading.close();
        // Notification.warning({
        //   type: "info",
        //   title: "サインアウト",
        //   message:
        //     "既に別にアカウントからログインされていたので、一旦ログアウトしました。お手数ですがメールに記載されているURLをもう一度クリックしてください。"
        // });
      });
  }

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next("/");
  } else if (!requiresAuth && currentUser) {
    next("/dashboard");
  } else {
    next();
  }
});

// router.afterEach(() => {
//   document.getElementById("app").scrollIntoView();
// });

export default router;
